export default __webpack_public_path__ + "static/media/why-gritX.ad9e7e10.svg";